"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  root: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: '5px 0'
  },
  radio: {
    flexShrink: 0,
    height: '15px',
    width: '15px',
    marginRight: '10px',
    fill: function fill(_ref) {
      var selected = _ref.selected;
      return selected ? _styles.colors.blue : _styles.colors.gray;
    }
  },
  radioBorder: {
    fill: _styles.colors.gray
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  inputEl: {
    display: 'none'
  }
};
var _default = styles;
exports["default"] = _default;